import { render } from "./OapImmersiveHotspots.vue?vue&type=template&id=53bb5b0c"
import script from "./OapImmersiveHotspots.vue?vue&type=script&lang=js"
export * from "./OapImmersiveHotspots.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__